export default __webpack_public_path__ + "static/media/adExchange.24d9e9f8.png";